import { isNativeApp } from "./platform";

// Detectado automaticamente pelo host presente no `window` (RNBridge = Android,
// CefSharp = Windows). Ver src/utils/platform.ts para a ordem de decisão e para
// o override manual de debug (`@meep/forcePlatform` no localStorage).
export const isReactNative = isNativeApp();

// Flag para habilitar/desabilitar modal de erro de impressão
// Quando true: sistema aguarda ação do usuário (retry ou skip) antes de continuar
// Quando false: sistema apenas registra o erro e continua com próximas impressões
export const PRINT_ERROR_MODAL = true;
